import {
  BaseSyntheticEvent,
  Dispatch,
  KeyboardEvent,
  MouseEvent,
  SetStateAction,
} from "react";

const checksWithTemplates = [
  "QUESTIONNAIRE",
  "EMPLOYMENT_VERIFICATIONS",
  "DIGITAL_REFERENCE_CHECKS",
  "REFERENCE_1",
];
export const checkHasTemplate = (type: string) => {
  return checksWithTemplates.includes(type);
};

const ORDERING_CHECK_CARD_ROOT_TEST_ID_SUFFIXES = [
  "-order-check-card-selected",
  "-order-check-card-unselected",
  "-order-check-card",
] as const;

function isOrderingCheckCardRoot(element: Element): boolean {
  const testId = element.getAttribute("data-testid");
  return (
    testId !== null &&
    ORDERING_CHECK_CARD_ROOT_TEST_ID_SUFFIXES.some((suffix) =>
      testId.endsWith(suffix)
    )
  );
}

export function useOrderingCheckCardHandlers(
  isDisabled: boolean,
  isRequiredCheck: boolean,
  setIsCardSelected: Dispatch<SetStateAction<boolean>>,
  isCardSelected: boolean,
  onPress?: () => void,
  showRemoveWhenSelected = false,
  setShowModal?: Dispatch<SetStateAction<boolean>>
) {
  const isInteractiveTarget = (target: EventTarget | null) => {
    if (!(target instanceof Element)) {
      return false;
    }

    const interactive = target.closest(
      'a, button, input, textarea, select, label, [role="checkbox"], [role="radio"], [role="switch"]'
    );

    if (!interactive || isOrderingCheckCardRoot(interactive)) {
      return false;
    }

    return true;
  };

  const handleClick = (
    event: MouseEvent<HTMLDivElement> & BaseSyntheticEvent<HTMLDivElement>
  ) => {
    if (isDisabled || isRequiredCheck || isInteractiveTarget(event.target)) {
      return;
    }

    if (showRemoveWhenSelected && isCardSelected) {
      setShowModal?.(true);
      return;
    }

    setIsCardSelected(!isCardSelected);
    if (onPress) {
      event.preventDefault();
      onPress();
    }
  };

  const handleKeyDown = (
    event: KeyboardEvent<HTMLDivElement> & BaseSyntheticEvent<HTMLDivElement>
  ) => {
    if (isDisabled || isRequiredCheck || isInteractiveTarget(event.target)) {
      return;
    }
    if (event.key === "Enter" || event.key === " ") {
      if (showRemoveWhenSelected && isCardSelected) {
        event.preventDefault();
        setShowModal?.(true);
        return;
      }

      setIsCardSelected(!isCardSelected);
      if (onPress) {
        event.preventDefault();
        onPress();
      }
    }
  };

  return { handleClick, handleKeyDown };
}
